export const GENERAL_FAQS = [
  {
    q: "Are you a real general contractor or a roofer?",
    a: "Black Ridge Construction is a real general contractor for Central Texas. We handle roofing, remodeling, additions, repairs, outdoor living, and ongoing home maintenance memberships under one team. Roofing is one of the services we self-perform and document, not our entire business.",
  },
  {
    q: "Do you serve my city in Central Texas?",
    a: "We serve Austin and the surrounding Central Texas area — including Round Rock, Cedar Park, Georgetown, Pflugerville, Hutto, Kyle, Buda, San Marcos, Dripping Springs, Wimberley, Lakeway, Bee Cave, Manor, Bastrop, Elgin, Taylor, Liberty Hill, and many more. See our Service Areas page for the full list.",
  },
  {
    q: "How are estimates handled?",
    a: "We meet, walk the project, talk through goals and constraints, and provide a clear scope and price. We do not pressure homeowners and we do not promise outcomes we cannot deliver.",
  },
  {
    q: "Do you guarantee insurance approvals on roof claims?",
    a: "No. No honest contractor can promise an insurance outcome. We document conditions with photos, provide our inspection findings, and support homeowners through the process — but the insurance decision is between the homeowner and the carrier.",
  },
  {
    q: "How are payments handled?",
    a: "Payment terms are project-specific and outlined in your written contract. We typically work with a clear deposit, progress milestones, and a final payment on completion. Card-on-file and autopay are used for maintenance memberships.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Black Ridge Construction operates with general liability coverage and uses appropriately licensed trade partners when work requires licensed electrical, plumbing, HVAC, or other regulated scopes.",
  },
  {
    q: "Do you offer warranties on completed work?",
    a: "Yes. Project-specific warranty terms are written into your contract and depend on the type of work performed. Roofing warranties depend on materials and labor scope.",
  },
  {
    q: "Can I see examples of past work?",
    a: "Yes. See our Testimonials page for client experiences and project stories across Austin and Central Texas. Additional project photos are available on request.",
  },
];

export const MAINTENANCE_FAQS = [
  {
    q: "What makes this different from hiring a handyman once?",
    a: "A membership gives Black Ridge a recurring relationship with the property. We document the home, track visible conditions, perform scheduled checks, and help you stay ahead of maintenance instead of only reacting when something breaks.",
  },
  {
    q: "Do I get a report after each visit?",
    a: "Yes. Each visit is designed to create a clear summary of completed items, visible concerns, deferred items, photo notes, and recommended next steps.",
  },
  {
    q: "Is the first inspection required?",
    a: "Yes. The baseline inspection helps document the starting condition of the property and creates the home profile used for future visits.",
  },
  {
    q: "What happens if you find a repair?",
    a: "Small approved add-ons may be handled at the current member crew-hour rate. Larger, licensed, unsafe, or multi-trade items are routed to a formal contractor-service estimate.",
  },
  {
    q: "Are emergency calls included?",
    a: "Phone triage is included for active members in good standing. Emergency dispatch has separate dispatch fees and crew-hour pricing unless a specific plan includes an emergency credit.",
  },
  {
    q: "Why do I provide filters and batteries?",
    a: "Client-supplied routine materials help keep the monthly membership affordable and prevent delays from brand, size, or preference differences.",
  },
  {
    q: "Is this a warranty?",
    a: "No. This is a scheduled maintenance and documentation membership. It helps catch visible issues earlier and keeps routine tasks on schedule, but it does not guarantee systems will not fail.",
  },
  {
    q: "Can unused hours roll over?",
    a: "No. Included time does not automatically roll over, bank, or convert to cash. Any same-visit credit must be approved and documented.",
  },
  {
    q: "Can Black Ridge handle repairs outside the plan?",
    a: "Yes. Black Ridge can provide a separate contractor-service estimate for repairs, roofing, remodeling, exterior work, and larger scopes outside the maintenance membership.",
  },
  {
    q: "Is the maintenance plan home insurance?",
    a: "No. Black Ridge maintenance plans are maintenance memberships and repair reserve agreements. They are not insurance, home warranties, or unlimited-repair programs.",
  },
  {
    q: "Are pre-existing conditions covered?",
    a: "No. Pre-existing conditions are excluded unless repaired and documented first. A baseline inspection is part of activation.",
  },
  {
    q: "Is there a waiting period?",
    a: "A 30-day waiting period applies to new enrollments unless the plan is sold at project closeout or immediately after documented repair completion.",
  },
];
